import { LatLngTuple } from "@tuliu/leaflet";

/**
 * 去除重复元素
 * @param list
 */
export function removeDuplicateItem(list: LatLngTuple[]) {
  const hashMap: Record<string, boolean> = {};
  for (let i = list.length - 1; i >= 0; i--) {
    const key = list[i].join(",");
    if (hashMap[key]) {
      list.splice(i, 1);
    } else {
      hashMap[key] = true;
    }
  }
  return list;
}
